// extracted by mini-css-extract-plugin
export var paginationContainer = "_74-0";